(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;
  function pageGlow() {
    if (!fine || reduce || document.querySelector('.lb-glow-page')) return;
    var g = document.createElement('div'); g.className = 'lb-glow-page'; g.setAttribute('aria-hidden', 'true'); document.body.appendChild(g);
    var tx = window.innerWidth / 2, ty = window.innerHeight / 2, x = tx, y = ty, running = false;
    function frame() {
      x += (tx - x) * .18; y += (ty - y) * .18;
      g.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
      if (Math.abs(tx - x) > .5 || Math.abs(ty - y) > .5) requestAnimationFrame(frame); else running = false;
    }
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      tx = e.clientX; ty = e.clientY; g.classList.add('is-on');
      if (!running) { running = true; requestAnimationFrame(frame); }
    }, { passive: true });
    document.documentElement.addEventListener('pointerleave', function () { g.classList.remove('is-on'); });
    window.addEventListener('blur', function () { g.classList.remove('is-on'); });
  }

  function videos(root) {
    (root || document).querySelectorAll('[data-lb-video]').forEach(function (w) {
      if (w.dataset.ready) return; w.dataset.ready = '1';
      var v = w.querySelector('video'), b = w.querySelector('[data-lb-sound]');
      if (!v) return;
      v.muted = true; v.playsInline = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      if (!b) return; b.hidden = false;
      b.addEventListener('click', function () { v.muted = !v.muted; b.setAttribute('aria-pressed', v.muted ? 'false' : 'true'); b.setAttribute('aria-label', v.muted ? 'Activar sonido' : 'Silenciar'); if (v.paused) v.play(); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { pageGlow(); videos(); });
  else { pageGlow(); videos(); }
  document.addEventListener('shopify:section:load', function (e) { videos(e.target); });
})();